import React from 'react'
import { HiArrowNarrowRight } from 'react-icons/hi'
const Home = () => {
  return (
    <div>
      <div name="home" className="w-full h-screen bg-[#0a192f]">
        {/* Container */}
        <div className="max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full">
          <p className=" text-orange-700">Hai, Nama saya</p>
          <h1 className="text-4xl sm:text-7xl font-bold text-[#ccd6f6]">
            Arlando Irwan Jaya Diwalsa
          </h1>
          <h2 className="text-xl sm:text-5xl font-bold text-[#8892b0]">
            saya front end developer
          </h2>
          <p className="text-[#8892b0] py-4 max-w-[700px]">
            Saya seorang front end developer yang fokus membangun aplikasi web
            yang responsif.
          </p>
          <div>
            <button className="text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-orange-700 hover:border-orange-700">
              View Work
              <span className="group-hover:rotate-90 duration-300">
                <HiArrowNarrowRight className="ml-3 " />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Home
